import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("seifried_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem("seifried_token");
      localStorage.removeItem("seifried_user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Ein Fehler ist aufgetreten.") =>
  e?.response?.data?.detail || e?.message || fallback;

// ---- Formatierung (de-AT) ----
export const fmtNum = (v, digits = 0) =>
  v === null || v === undefined
    ? "–"
    : Number(v).toLocaleString("de-AT", { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const fmtKg = (v) => `${fmtNum(v, 0)} kg`;
export const fmtEur = (v) =>
  v === null || v === undefined
    ? "–"
    : Number(v).toLocaleString("de-AT", { style: "currency", currency: "EUR" });
export const fmtCent = (v, digits = 3) => `${fmtNum(v, digits)} ct/kg`;

export const fmtDate = (iso) => {
  if (!iso) return "–";
  const [j, m, t] = iso.split("-");
  return `${t}.${m}.${j}`;
};

const MONATE = ["Jänner", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember"];

export const fmtMonat = (monat) => {
  if (!monat) return "–";
  const [j, m] = monat.split("-");
  return `${MONATE[parseInt(m, 10) - 1]} ${j}`;
};

export const aktuellerMonat = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const letzteMonate = (n = 14) => {
  const out = [];
  const d = new Date();
  d.setDate(1);
  for (let i = 0; i < n; i++) {
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return out;
};

export const downloadCsv = (dateiname, spalten, zeilen) => {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [spalten.map(esc).join(";"), ...zeilen.map((z) => z.map(esc).join(";"))].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = dateiname;
  a.click();
  URL.revokeObjectURL(url);
};

export const downloadBlob = async (url, dateiname) => {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = dateiname;
  a.click();
  URL.revokeObjectURL(blobUrl);
};
